// API constants
export const BROWSE_API_PAGE_SIZE = 24;
export const BROWSE_API_FACETS_STALE_TIME = 1000 * 60 * 60 * 24; // 24 hours
export const BROWSE_API_RESULTS_STALE_TIME = 1000 * 60 * 60 * 24; // 24 hours
export const FED_GRAPH_PRICING_STALE_TIME = 1000 * 60 * 5; // 5 minutes
export const FED_GRAPH_RELATED_PRODUCTS_STALE_TIME = 1000 * 60 * 5; // 5 minutes

// LHN (Left Hand Nav) constants
export const LHN_WIDTH = 268;
export const GAP_BETWEEN_LHN_AND_VIRTUAL_SCROLL = 32;
export const LHN_WIDTH_WITH_PADDING =
  LHN_WIDTH + GAP_BETWEEN_LHN_AND_VIRTUAL_SCROLL;

// Grid Layout constants
export const OUTER_GRID_PADDING_MOBILE = 16 * 2;
export const OUTER_GRID_PADDING_DESKTOP = 32 * 2;
export const GAP_BETWEEN_GRID_COLUMNS_MOBILE = 8;
export const GAP_BETWEEN_GRID_COLUMNS_DESKTOP = 30;
export const GAP_BETWEEN_GRID_ROWS = 30;
export const MAX_GRID_WIDTH = 968;

// Grid Card constants
const RESERVED_GRID_SWATCHES_HEIGHT = 32 + 2 * 8; // swatches + vertical padding
const RESERVED_PRODUCT_INFO_HEIGHT = 110; // max product card name, promo, price, marketing callout
const RESERVED_BUFFER_HEIGHT = 18; // 1 row of buffer space for text overflow on resize
export const RESERVED_SPACE_FOR_CARD_INFO =
  RESERVED_GRID_SWATCHES_HEIGHT +
  RESERVED_PRODUCT_INFO_HEIGHT +
  RESERVED_BUFFER_HEIGHT;
export const MAX_CARD_WIDTH = 303;
export const GRID_CARD_TYPES = {
  PRODUCT: 'product',
  ASSET: 'asset',
};
export const DEFAULT_VIDEO_ASPECT_RATIO = 1.4; // refer to productGrid.js for more details

// Virtual Scroll constants
export const RESIZE_THROTTLE = 0; // increase this if we see performance issues, keep close to 0 for smoothness
export const VIRTUAL_SCROLL_OVERSCAN = 5; // number of virtual rows to render above and below the viewport
export const VIRTUAL_SCROLL_GRID_ID = 'builder-cio-virtual-scroll-grid'; // anchor for scrolling to the top of the grid after a filter or sort option is applied
export const VIRTUAL_SCROLL_GRID_SCROLL_OFFSET = -130; // offset to show the grid header after scrolling to the top of the grid
export const VIRTUAL_SCROLL_GRID_SCROLL_DELAY = 100; // delay to allow for any layout changes before scrolling
